/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { useEffect } from 'react'

function useDisableZoomSite() {
  useEffect(() => {
    document.addEventListener(
      'touchstart',
      event => {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      },
      { passive: false },
    )
    let lastTouchEnd = 0
    document.addEventListener(
      'touchend',
      event => {
        const now = new Date().getTime()
        if (now - lastTouchEnd <= 300) {
          event.preventDefault()
        }
        lastTouchEnd = now
      },
      false,
    )
  }, [])
}

export default useDisableZoomSite
